import {
  OBTENIR_INDIVIDUS_LLISTAT,
  OBTENIR_INDIVIDU_ID,
  ESBORRAR_INDIVIDU_SELECCIONAT,
  OBTENIR_DADES_INDIVIDU,
  INDIVIDU_INTRODUCCIO_MODIFICAR_CAMP,
  INDIVIDU_INICIALITZAR,
  INDIVIDU_INTRODUCCIO_DESCARTAR_CANVIS,
  OBTENIR_DADES_CREACIO_INDIVIDU,
  INDIVIDU_INTRODUCCIO_MOSTRAR_ERRORS,
  INDIVIDU_INTRODUCCIO_ENVIAR_FORMULARI_EN_CURS,
  INDIVIDU_INTRODUCCIO_ENVIAR_FORMULARI_FINALITZADA
} from "./actionTypes";
import {
  fetchObtenirIndividusLlistat,
  fetchObtenirDadesIndividu,
  fetchObtenirDadesCreacioIndividu,
  fetchIndividuIntroduccioCrearIndividu,
  fetchIndividuIntroduccioEditarIndividu
} from "./consultesServidor";

import {
  crearNotificacioDadesNoCanviades,
  crearNotificacioFormulariFaltenDadesObligatories,
  crearNotificacioSuccess,
  crearNotificacioError
} from "../utils/notificacio";

import {
  formulariNoShanModificatDades,
  obtenirErrorsDadesIndividu,
  hiHaErrorsDadesFormulari
} from "../utils/formularis";
import { ID_CLASSE_VEGETAL } from "../constantsFormularis";

import { errorConsultaServidor } from "./error";
import { rutaIndividus } from "../routes";

export const obtenirIndividusLlistat = () => {
  return {
    type: OBTENIR_INDIVIDUS_LLISTAT,
    promise: fetchObtenirIndividusLlistat()
  };
};

export const getDadesIndividuSeleccionat = idIndividu => {
  return {
    type: OBTENIR_INDIVIDU_ID,
    payload: idIndividu
  };
};

export const esborrarIndividuSeleccionat = () => {
  return {
    type: ESBORRAR_INDIVIDU_SELECCIONAT,
    payload: null
  };
};

export const obtenirDadesIndividu = idIndividu => {
  return {
    type: OBTENIR_DADES_INDIVIDU,
    promise: fetchObtenirDadesIndividu(idIndividu)
  };
};

export const obtenirDadesCreacioIndividu = () => {
  return {
    type: OBTENIR_DADES_CREACIO_INDIVIDU,
    promise: fetchObtenirDadesCreacioIndividu()
  };
};

export const individuIntroduccioModificarCamp = (idCamp, valor) => {
  return {
    type: INDIVIDU_INTRODUCCIO_MODIFICAR_CAMP,
    idCamp,
    valor
  };
};

export const inicialitzarIndividu = () => {
  return {
    type: INDIVIDU_INICIALITZAR,
    payload: null
  };
};

export const individuIntroduccioDescartarCanvis = () => {
  return {
    type: INDIVIDU_INTRODUCCIO_DESCARTAR_CANVIS
  };
};

export const individuIntroduccioEnviarFormulari = routerHistory => {
  return (dispatch, getState) => {
    const estat = getState();
    const idIndividu = estat.individus.dades.idIndividuSeleccionat;
    const edicioIndividu = idIndividu ? true : false;
    const esIndividuVegetal =
      parseInt(estat.individus.formulari.editades.idClasse) ===
      ID_CLASSE_VEGETAL
        ? true
        : false;

    const dadesOriginals = estat.individus.formulari.originals;
    const dadesEditades = estat.individus.formulari.editades;
    const errors = obtenirErrorsDadesIndividu(dadesEditades);
    const hiHaError = hiHaErrorsDadesFormulari(errors);
    if (hiHaError.length > 0) {
      dispatch(individuIntroduccioMostrarErrors());
      crearNotificacioFormulariFaltenDadesObligatories();
      return;
    }
    let promesa;
    const rutaRedireccionamentSiInsercioOk = rutaIndividus;
    let missatgeNotificacioExit;
    let missatgeNotificacioError;
    const especieIndividu = dadesEditades.nomEspecie || "";
    const descripcioIndividu = dadesEditades.descripcio || "";
    let fenofasesIguals = true;
    let especiesIguals = true;
    let observadorIndretIguals = true;
    if (formulariNoShanModificatDades(dadesOriginals, dadesEditades)) {
      crearNotificacioDadesNoCanviades();
      return;
    }

    if (idIndividu) {
      especiesIguals = dadesOriginals.idEspecie === dadesEditades.idEspecie;
      fenofasesIguals =
        especiesIguals === false
          ? false
          : formulariNoShanModificatDades(
              dadesOriginals.fenofases,
              dadesEditades.fenofases
            );
      observadorIndretIguals =
        dadesOriginals.idObservador === dadesEditades.idObservador &&
        dadesOriginals.idIndret === dadesEditades.idIndret;

      dispatch(individuIntroduccioEnviarFormulariEnCurs());
      const dadesAEnviar = obtenirFormDataAltaIndividu(
        dadesEditades,
        esIndividuVegetal,
        edicioIndividu,
        fenofasesIguals,
        especiesIguals,
        observadorIndretIguals,
        dadesOriginals
      );

      promesa = fetchIndividuIntroduccioEditarIndividu(
        idIndividu,
        dadesAEnviar
      );
      missatgeNotificacioExit = `Individu "${especieIndividu}" editat correctament`;
      missatgeNotificacioError = "Error editant l'individu";
    } else {
      // creant individu -> individu_vegetal -> Indret_individu -> individu_fenofase
      dispatch(individuIntroduccioEnviarFormulariEnCurs());

      const dadesAEnviar = obtenirFormDataAltaIndividu(
        dadesEditades,
        esIndividuVegetal,
        edicioIndividu,
        fenofasesIguals,
        especiesIguals,
        observadorIndretIguals
      );

      promesa = fetchIndividuIntroduccioCrearIndividu(dadesAEnviar);
      missatgeNotificacioExit = `Individu "${especieIndividu}, ${descripcioIndividu}" creat correctament`;
      missatgeNotificacioError = "Error creant l'individu";
    }

    return promesa.then(
      result => {
        dispatch(individuIntroduccioEnviarFormulariFinalitzada());

        if (result && (result.msg || result.message)) {
          return crearNotificacioError(result.msg || result.message);
        }
        crearNotificacioSuccess(missatgeNotificacioExit);
        routerHistory.push(rutaRedireccionamentSiInsercioOk);
      },
      errorServidor => {
        dispatch(individuIntroduccioEnviarFormulariFinalitzada());
        dispatch(
          errorConsultaServidor(errorServidor, missatgeNotificacioError)
        );
      }
    );
  };
};

const obtenirFormDataAltaIndividu = (
  dades,
  esVegetal,
  edicioIndividu,
  fenofasesIguals,
  especiesIguals,
  observadorIndretIguals,
  dadesOriginals
) => {
  let dadesTransformades = Object.assign({}, dades);
  dadesTransformades.esIndividuVegetal = esVegetal;
  delete dadesTransformades.id;
  delete dadesTransformades.motiuBaixa;
  delete dadesTransformades.dataBaixa;
  delete dadesTransformades.nomObservador;
  delete dadesTransformades.nomCientific;
  delete dadesTransformades.idIndividuVegetal;
  delete dadesTransformades.nomIndret;
  delete dadesTransformades.nomEspecie;
  delete dadesTransformades.nomSubespecie;
  delete dadesTransformades.nomVarietat;
  delete dadesTransformades.idGenere;
  delete dadesTransformades.nomGenere;
  delete dadesTransformades.idCollectiu;
  delete dadesTransformades.nomCollectiu;
  delete dadesTransformades.idClasse;
  delete dadesTransformades.nomClasse;
  delete dadesTransformades.idRegne;
  delete dadesTransformades.nomRegne;

  if (edicioIndividu) {
    const canviarPropsFenofases = dadesTransformades.fenofases.map(fenofase => {
      const fenofaseTransformada = {
        key: fenofase.idFenofase ? fenofase.idFenofase : fenofase.key,
        label: fenofase.nomFenofase ? fenofase.nomFenofase : fenofase.label
      };
      return fenofaseTransformada;
    });
    delete dadesTransformades.fenofases;
    dadesTransformades.fenofases = canviarPropsFenofases;
    dadesTransformades.fenofasesIguals = fenofasesIguals;
    delete dadesTransformades.nomComu;
    delete dadesTransformades.idFenofase;
    dadesTransformades.especiesIguals = especiesIguals;
    dadesTransformades.observadorIndretIguals = observadorIndretIguals;
    if (dadesTransformades.observadorIndretIguals === false) {
      dadesTransformades.idIndretOriginal = dadesOriginals.idIndret;
    }
  } else {
    const canviarPropsFenofases = dadesTransformades.fenofases.map(fenofase => {
      const fenofaseTransformada = {
        key: parseInt(fenofase.key),
        label: fenofase.label
      };
      return fenofaseTransformada;
    });
    delete dadesTransformades.fenofases;
    delete dadesTransformades.canvis;
    dadesTransformades.fenofases = canviarPropsFenofases;
    dadesTransformades.fenofasesIguals = fenofasesIguals;
    dadesTransformades.observadorIndretIguals = observadorIndretIguals;
  }

  return dadesTransformades;
};

const individuIntroduccioMostrarErrors = () => ({
  type: INDIVIDU_INTRODUCCIO_MOSTRAR_ERRORS
});

const individuIntroduccioEnviarFormulariEnCurs = () => ({
  type: INDIVIDU_INTRODUCCIO_ENVIAR_FORMULARI_EN_CURS
});

const individuIntroduccioEnviarFormulariFinalitzada = () => ({
  type: INDIVIDU_INTRODUCCIO_ENVIAR_FORMULARI_FINALITZADA
});
